import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Category from "./Category";
import { device, size } from "constants/Devices";
import { IBlogAuthor, ICategory } from "types/interfaces/blog/IBlog";
import { sanityImgBuilder as builder } from "../sanity";
import { ROUTES } from "routes/constants";
import { Typography } from "@beamcloud/design-system";
import Author from "./Author";

interface IProps {
  title: string;
  description: string;
  categories: ICategory[];
  author: IBlogAuthor;
  coverImage: any;
  slug: string;
}

const ArticleCard = ({ title, description, coverImage, categories, author, slug }: IProps) => {
  return (
    <Card>
      <Link to={`${ROUTES.blog}/${slug}`}>
        <CardImage
          alt="card-cover-image"
          src={builder
            .image(coverImage)
            // .height(228)
            // .width(456)
            // .fit("max")
            .url()}
        />
      </Link>
      <Categories>
        {categories.map((category, id) => (
          <Category key={id} size="small" category={category} />
        ))}
      </Categories>
      <Typography tag="h1" variant="title2Xl" color="gray100">
        <Link to={`${ROUTES.blog}/${slug}`}>{title}</Link>
      </Typography>
      <Typography tag="p" variant="textBase" color="gray300">
        {description}
      </Typography>
      <CardAuthor author={author} size="small" />
    </Card>
  );
};

export default ArticleCard;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 12px;
  width: 456px;

  @media ${device.mobileXL} {
    width: ${size.mobileS}px;
  }
`;

const CardImage = styled.img`
  border-radius: 8px;
  max-width: 100%;

  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`;

const Categories = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  padding: 12px 0px 4px;
  gap: 8px;
`;

const CardAuthor = styled(Author)`
  padding: 12px 0px 0px;
`;
